import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { resolveLabel } from '@/lib/fieldLabel';

const TABLE_CALC_OPTIONS = [
  ['none', 'None'],
  ['running_total', 'Running Total'],
  ['pct_of_total', '% of Total'],
  ['rank', 'Rank'],
  ['difference', 'Difference'],
  ['pct_difference', '% Difference'],
  ['moving_avg', 'Moving Average'],
  ['running_avg', 'Running Average'],
  ['running_min', 'Running Min'],
  ['running_max', 'Running Max'],
  ['yoy', 'Year-over-Year'],
  ['prior_period', 'Prior Period'],
  ['growth_rate', 'Growth Rate %'],
  ['dense_rank', 'Dense Rank'],
  ['ntile', 'Quartile (NTILE)'],
  ['percentile_rank', 'Percentile Rank'],
  ['rolling_sum_3', 'Rolling Sum (3)'],
  ['index_to_first', 'Index to First'],
  ['zscore', 'Z-Score'],
];

export function TableCalculations({ valueMeasures, tableCalcs, setTableCalcs, allFields }) {
  return (
    <div className="p-3 border-b border-border/30">
      <div className="flex items-center justify-between mb-1">
        <p className="text-[9px] text-muted-foreground uppercase tracking-wider font-semibold">Table Calculations</p>
      </div>
      {valueMeasures.map(m => (
        <div key={m} className="flex items-center gap-1 mb-1">
          <span className="text-[8px] text-muted-foreground truncate w-20" title={resolveLabel(allFields, m)}>{resolveLabel(allFields, m)}</span>
          <Select value={tableCalcs[m] || 'none'} onValueChange={v => setTableCalcs(prev => ({ ...prev, [m]: v }))}>
            <SelectTrigger className="!h-6 !text-[9px] rounded bg-muted/30 border-border/30 flex-1"><SelectValue /></SelectTrigger>
            <SelectContent>
              {TABLE_CALC_OPTIONS.map(([value, label]) => (
                <SelectItem key={value} value={value}>{label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      ))}
      {valueMeasures.length === 0 && <p className="text-[8px] text-muted-foreground/30 italic">Add measures first</p>}
    </div>
  );
}
